<template>
  <div>
    <article class="con1">
      <div class="container">
        <p class="text0">CARROT GLOBAL 신입/경력 수시 채용</p>
        <img
          src="@/assets/img/newGlobal/introduce/sub/recruit/con1/img.jpg"
          alt="img"
          class="people-img"
        />
        <p class="text1">
          서로에게서 최고의 것을 발견하고, 최고의 것을 주는 사람들<br />우리는
          CARROT입니다.
        </p>
        <p class="text2">최고를 지향하는 Next CARROTian을 찾습니다!</p>
        <img
          src="@/assets/img/newGlobal/introduce/sub/recruit/con1/carrotglobal_logo_png.png"
          alt="logo"
          class="logo"
        />
      </div>
    </article>
  </div>
</template>

<script>
import "@/assets/style/newGlobalReset.scss";

export default {};
</script>

<style lang="scss" scoped>
.con1 {
  padding: 40px 0;

  @media screen and (min-width: 1350px) {
    padding: 80px 0;
  }

  .text0 {
    font-size: 18px;
    text-align: center;
    margin-bottom: 20px;
  }

  .people-img {
    width: 100%;
    margin-bottom: 50px;
  }

  .text1 {
    font-size: 18px;
    text-align: center;
    margin-bottom: 10px;
  }

  .text2 {
    font-size: 23px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 50px;
  }

  .logo {
    max-width: 148px;
    margin: 0 auto;
  }
}
</style>
